// Yalnız sekmenin belleğinde okuma konumu; kart/profil/token saklanmaz.
export type FeedPosition = {
  pages: number;
  eventId: string;
  top: number;
  focus: string;
  at: number;
};
const positions = new Map<string, FeedPosition>();
let owner: string | null = null;
export function setFeedPositionOwner(next: string) {
  if (owner !== null && owner !== next) positions.clear();
  owner = next;
}
const TTL = 5 * 60 * 1000;
export const MAX_RESTORE_PAGES = 10;

export function saveFeedPosition(key: string, value: FeedPosition) {
  positions.delete(key);
  positions.set(key, { ...value, pages: Math.min(MAX_RESTORE_PAGES, value.pages) });
  while (positions.size > 4) positions.delete(positions.keys().next().value as string);
}

export function takeFeedPosition(key: string, now = Date.now()): FeedPosition | null {
  const value = positions.get(key);
  positions.delete(key);
  return value && now - value.at < TTL ? value : null;
}

export const clearFeedPositions = () => positions.clear();
